import { Component, ViewChild } from '@angular/core';
import {UserService} from '../_services';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent {

    public records: any[] = [];
    @ViewChild('csvReader', {static:false}) csvReader: any;

    constructor(private userService: UserService) {

    }

    uploadListener($event: any): void {

      let text = [];
      let files = $event.srcElement.files;

      if (this.isValidCSVFile(files[0])) {

        let input = $event.target;
        let reader = new FileReader();
        reader.readAsText(input.files[0]);

        reader.onload = () => {
          let csvData = reader.result;
          let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);

          let headersRow = this.getHeaderArray(csvRecordsArray);

          this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        };

        reader.onerror = function () {
          console.log('error is occured while reading file!');
        };

      } else {
        alert("Please import valid .csv file.");
        this.fileReset();
      }
    }

    getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
      let csvArr = [];

      for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = (<string>csvRecordsArray[i]).split(';');
        let csvRecord: CSVRecord = new CSVRecord();
        csvRecord.firstName = curruntRecord[2].trim();
        csvRecord.lastName = curruntRecord[1].trim();
        csvRecord.email = curruntRecord[3].trim();
        csvRecord.status = curruntRecord[4].trim();
        csvRecord.aidants = parseInt(curruntRecord[8].trim());
        csvArr.push(csvRecord);

        let user = {
          "firstname": csvRecord.firstName,
          "lastname": csvRecord.lastName,
          "email": csvRecord.email,
          "username": csvRecord.email,
          "emailVerified": true,
          "password": csvRecord.firstName.toLowerCase() + "&2019"
        }

        this.userService.register(user).pipe(first()).subscribe(result => {});

        for(let i = 1; i <= csvRecord.aidants; i++) {
          let aidant = {
            "firstname": 'Aidant',
            "lastname": i,
            "email": csvRecord.firstName.toLowerCase()+'_aidant_'+i+"@lexibee.io",
            "username": csvRecord.firstName.toLowerCase()+'_aidant_'+i+"@lexibee.io",
            "emailVerified": true,
            "password": csvRecord.firstName.toLowerCase() + "&2019"
          }

          this.userService.register(aidant).pipe(first()).subscribe(result => {});
        }

      }
      return csvArr;
    }

    isValidCSVFile(file: any) {
      return file.name.endsWith(".csv");
    }

    getHeaderArray(csvRecordsArr: any) {
      let headers = (<string>csvRecordsArr[0]).split(';');
      let headerArray = [];
      for (let j = 0; j < headers.length; j++) {
        headerArray.push(headers[j]);
      }
      return headerArray;
    }

    fileReset() {
      this.csvReader.nativeElement.value = "";
      this.records = [];
    }
}


export class CSVRecord {
    public lastName: any;
    public firstName: any;
    public email: any;
    public status: any;
    public aidants: any;
  }
